/**
 * Tabela da aba "Solicitações" do Painel — é a `TabelaExcel` compartilhada,
 * com a identidade (larguras salvas) e as margens deste card.
 */
import React from "react";

import TabelaExcel, { largurasQueCabem } from "../../../components/TabelaExcel";

export { largurasQueCabem };

export default function TabelaSolicitacoes(props) {
  return (
    <TabelaExcel
      tableId="painel-assistencias-solicitacoes"
      estiloCaixa={{ margin: "0 -18px -18px" }}
      {...props}
    />
  );
}
